module.exports = __webpack_public_path__ + "static/media/icsi_badge.e6e665bd.png";